import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { CreateMerchSuccess } from '@webapp/store/merch/action-creators';
import { CREATE_MERCH_SUCCESS } from '@webapp/store/merch/actions';
import AppState from '@webapp/store/state';

export const merchProductCreated = (
  action$: Observable<CreateMerchSuccess>,
  state$: Observable<AppState>
) =>
  action$.pipe(
    ofType(CREATE_MERCH_SUCCESS),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (window.analytics) {
        window.analytics.track('Product Created', {
          created_by: 'User',
          products: [
            {
              product_id: action.merch.productId,
              name: state.merch.active?.product?.title,
              category: ['Merch'], // Static for now
              size: state.merch.active?.selectedSizes,
              color: state.merch.active?.selectedColors,
              position: state.merch.active?.position,
              index: state.merch.artistMerch.length,
            },
          ],
        });
      }
    }),
    filter(() => false)
  );
